module.exports = __webpack_public_path__ + "static/media/enterprise.da131e31.jpg";